import React, { FC } from 'react'
import styles from './InputSourceSelector.module.scss'
import Label from '../Label'
import OptionsSelect from '../OptionsSelect'
import InputSourceSelectorProps from './types'
import classnames from 'classnames'

const InputSourceSelector: FC<InputSourceSelectorProps> = props => {

  const optionsSelect = !!props.options.length &&
    <OptionsSelect
      inputId={`input-picker-${props.sourceType}`}
      dataBdd={`input-picker-${props.sourceType}`}
      placeholder={props.optionsPlaceholderText || `Select a ${props.sourceType}`}
      value={props.disabled && props.disabledText ? props.disabledText : props.selectedOption}
      options={props.options}
      onChange={props.onOptionChange}
      disabled={props.disabled}
      className={classnames({
        [styles['input-selector-disabled']]: props.disabled
      })}
    />

  const inputSourceSelectorClasses = classnames(
    styles['input-source-select'], {
      [styles['input-selector-column-layout']]: props.column,
      [styles['input-select--microphone-column']]: props.column && props.sourceType === 'microphone',
      [styles['input-select--camera-column']]: props.column && props.sourceType === 'camera',
      [styles['input-source-select--no-label']]: !props.label
    },
    props.classNames
  )

  return <div className={inputSourceSelectorClasses}>
    <span className={styles['input-source-select-label']}><Label>{props.label}</Label></span>
    <div className={styles['input-select']}>
      {
        React.isValidElement(props.switchComponent)
          ? <div className={styles['input-select--switch-layout']} ><span>{props.switchComponent}</span>{optionsSelect}</div>
          : optionsSelect
      }
    </div>
    <div data-bdd='input-preview' className={`${styles['input-feed']}`}>
      {props.previewComponent}
    </div>
  </div>

}

InputSourceSelector.defaultProps = {
  column: false
}

export default InputSourceSelector
